import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Button, Field, Input, Spinner,
  Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, Title3,
} from "@fluentui/react-components";
import { api } from "../../api/client";
import { useCategories } from "../../api/hooks";

export function AdminCategoriesPage() {
  const qc = useQueryClient();
  const list = useCategories();
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");

  const create = useMutation({
    mutationFn: () => api.post("/api/categories", { name, slug }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["categories"] });
      setName(""); setSlug("");
    },
  });

  const remove = useMutation({
    mutationFn: (id: string) => api.del(`/api/categories/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["categories"] }),
  });

  return (
    <div>
      <Title3>Categories</Title3>
      <div style={{ display: "flex", gap: 8, alignItems: "flex-end", marginTop: 16 }}>
        <Field label="Name"><Input value={name} onChange={(_, d) => setName(d.value)} /></Field>
        <Field label="Slug (a-z, 0-9, -)"><Input value={slug} onChange={(_, d) => setSlug(d.value)} /></Field>
        <Button appearance="primary" disabled={!name || !slug || create.isPending} onClick={() => create.mutate()}>
          Add
        </Button>
      </div>
      <div style={{ marginTop: 16 }}>
        {list.isLoading ? <Spinner /> : (
          <Table size="small">
            <TableHeader>
              <TableRow>
                <TableHeaderCell>Name</TableHeaderCell>
                <TableHeaderCell>Slug</TableHeaderCell>
                <TableHeaderCell>Active</TableHeaderCell>
                <TableHeaderCell>Actions</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {(list.data ?? []).map((c) => (
                <TableRow key={c.id}>
                  <TableCell>{c.name}</TableCell>
                  <TableCell>{c.slug}</TableCell>
                  <TableCell>{c.isActive ? "Yes" : "No"}</TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => remove.mutate(c.id)}>Delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
